import React from 'react';

interface IconStepPrepareProps {
  className?: string;
  size?: number;
}

export const IconStepPrepare: React.FC<IconStepPrepareProps> = ({ className = '', size = 40 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
        fill="#ECECF0"
      />
      <g clipPath="url(#clip0_step_prepare)">
        <path
          d="M19.181 12.3444C19.2167 12.1532 19.3181 11.9806 19.4677 11.8563C19.6173 11.7321 19.8057 11.6641 20.0001 11.6641C20.1946 11.6641 20.3829 11.7321 20.5325 11.8563C20.6821 11.9806 20.7836 12.1532 20.8193 12.3444L21.6951 16.9761C21.7573 17.3053 21.9174 17.6082 22.1543 17.8452C22.3913 18.0822 22.6942 18.2422 23.0235 18.3044L27.6551 19.1802C27.8463 19.2159 28.0189 19.3174 28.1432 19.467C28.2674 19.6166 28.3355 19.8049 28.3355 19.9994C28.3355 20.1939 28.2674 20.3822 28.1432 20.5318C28.0189 20.6814 27.8463 20.7829 27.6551 20.8186L23.0235 21.6944C22.6942 21.7566 22.3913 21.9166 22.1543 22.1536C21.9174 22.3905 21.7573 22.6934 21.6951 23.0227L20.8193 27.6544C20.7836 27.8456 20.6821 28.0182 20.5325 28.1425C20.3829 28.2667 20.1946 28.3347 20.0001 28.3347C19.8057 28.3347 19.6173 28.2667 19.4677 28.1425C19.3181 28.0182 19.2167 27.8456 19.181 27.6544L18.3051 23.0227C18.2429 22.6934 18.0829 22.3905 17.8459 22.1536C17.609 21.9166 17.3061 21.7566 16.9768 21.6944L12.3451 20.8186C12.154 20.7829 11.9813 20.6814 11.8571 20.5318C11.7328 20.3822 11.6648 20.1939 11.6648 19.9994C11.6648 19.8049 11.7328 19.6166 11.8571 19.467C11.9813 19.3174 12.154 19.2159 12.3451 19.1802L16.9768 18.3044C17.3061 18.2422 17.609 18.0822 17.8459 17.8452C18.0829 17.6082 18.2429 17.3053 18.3051 16.9761L19.181 12.3444Z"
          stroke="#717182"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.6667 11.668V15.0013"
          stroke="#717182"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.3333 13.332H25"
          stroke="#717182"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3334 28.3333C14.2539 28.3333 15.0001 27.5871 15.0001 26.6667C15.0001 25.7462 14.2539 25 13.3334 25C12.4129 25 11.6667 25.7462 11.6667 26.6667C11.6667 27.5871 12.4129 28.3333 13.3334 28.3333Z"
          stroke="#717182"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_step_prepare">
          <rect width="20" height="20" fill="white" transform="translate(10 10)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconStepPrepare;
